import Vue from 'vue'
import VueRouter from 'vue-router'
import homeRoutes from './modules/home'
import storeRoutes from './modules/store'
import discoveryRoutes from './modules/discovery'
import cartRoutes from './modules/cart'
import settleRoutes from './modules/settle'
import activityPlaceRoutes from './modules/activityPlace'
import goodsRoutes from './modules/goods'
import mineRoutes from './modules/mine'
import takeCoupon from './modules/takeCoupon'
import takeRedpack from './modules/takeRedpack'
import lotteryTableRoutes from './modules/lotteryTable'

//路由重定向报错时用这个
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

export const asyncRoutes = [
  ...homeRoutes,
  ...storeRoutes,
  ...discoveryRoutes,
  ...cartRoutes,
  ...settleRoutes,
  ...activityPlaceRoutes,
  ...goodsRoutes,
  ...mineRoutes,
  ...takeCoupon,
  ...takeRedpack,
  ...lotteryTableRoutes,
  {
    path: '*',
    redirect: '/',
  },
]

const routes = [
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/views/Login'),
	},
	{
		path: '/loginPhone',
		name: 'LoginPhone',
		component: () => import('@/views/LoginPhone'),
	},
	{
		path: '/loginPhoneOther',
		name: 'LoginPhoneOther',
		component: () => import('@/views/LoginPhone/other'),
		meta: {
			keepAlive: true,
		},
	},
	{
		path: '/loginPhoneCode',
		name: 'LoginPhoneCode',
		component: () => import('@/views/LoginPhone/code'),
	},
	{
		path: '/loginPhonePassword',
		name: 'LoginPhonePassword',
		component: () => import('@/views/LoginPhone/password'),
	},
	{
		path: '/loginForget',
		name: 'LoginForget',
		component: () => import('@/views/LoginPhone/forget'),
	},
	// 注册成功中间页
	{
		path: '/registerSuccessTip',
		name: 'RegisterSuccessTip',
		component: () => import('@/views/Register/components/registerSuccessTip'),
	},
	//end 注册成功中间页
	{
		path: '/register',
		name: 'Register',
		component: () => import('@/views/Register'),
		meta: {
			keepAlive: true,
		},
	},
	{
		path: '/registerPassword',
		name: 'RegisterPassword',
		component: () => import('@/views/Register/password'),
	},
	{
		path: '/registerInviteCode',
		name: 'RegisterInviteCode',
		component: () => import('@/views/Register/inviteCode'),
	},
	{
		path: '/read-article',
		name: 'ReadArticle',
		component: () => import('@/views/ReadArticle'),
	},
	{
		path: '/alipayInWeixin',
		name: 'AlipayInWeixin',
		component: () => import('@/views/AlipayInWeixin'),
	},
	{
		path: '/preview/goodsDetail/:id',
		name: 'PreviewGoodsDetail',
		component: () => import('@/views/GoodsDetail/indexPreview.vue'),
		meta: {
			roles: ['distributor', 'customer'],
		},
	},
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

export default router
